<template>
  <HeadlineComponent>Registrierung</HeadlineComponent>
  <div v-if="!registration_enabled">
    Derzeit ist die Registrierung geschlossen.
  </div>
  <Form
    class="form-horizontal"
    @submit="onSubmit"
    :initialValues="{ food_preferences: 2 }"
    v-if="registration_enabled"
  >
    <div v-html="registration_text" class="quill-generated-text"></div>
    <p>Du musst alle Felder ausfüllen!</p>
    <UserForm pw-rules="required|min:6"></UserForm>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading"
        >Registrieren</LoadingButton
      >
    </div>
    <p>
      Oder hast du schon einen Account? Dann <a href="/login">Log dich ein!</a>
    </p>
  </Form>
</template>

<script>
import { defineComponent } from "vue";
import router from "../router";
import { useUserStore } from "../stores/user";
import { mapActions, mapState } from "pinia";
import { useAlertsStore } from "../stores/alerts";
import HeadlineComponent from "../components/HeadlineComponent.vue";
import { Form } from "vee-validate";
import userService from "../services/user.service.js";
import UserForm from "../components/UserForm.vue";
import LoadingButton from "../components/LoadingButton.vue";
import { useConfigStore } from "../stores/config";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default defineComponent({
  name: "RegisterView",
  components: { LoadingButton, UserForm, HeadlineComponent, Form },
  data() {
    return {
      loading: false,
    };
  },
  async mounted() {
    await useConfigStore().get();
  },
  methods: {
    ...mapActions(useUserStore, { setUser: "set" }),
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async onSubmit(values, actions) {
      this.loading = true;
      // check if form is valid...
      try {
        let response = await userService.register(values);
        if (response.data.success) {
          this.addAlert("success", response.data.message);
          router.push({ path: "/confirm", query: { email: values.email } });
        }
        window.scrollTo(0, 0);
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapState(useConfigStore, ["registration_text", "registration_enabled"]),
  },
});
</script>

<style scoped>
@media (max-width: 575px) {
  form {
    width: 100%;
    max-width: 330px;
    margin: 0 auto;
    padding: 15px;
  }
  .form-group {
    text-align: center;
  }
}
</style>
